<script setup>
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
</script>

<template>
  <div
    class="flex h-full w-full overflow-x-auto overflow-y-auto bg-n-surface-1 px-6 pb-8 pt-4 transition-colors dark:bg-[#0b1120]"
  >
    <div class="mx-auto flex w-full max-w-none items-start">
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
